<template>
  <el-dialog
    v-loading="loading"
    :visible="visible"
    width="80%"
    left
    :show-close="true"
    :title="$lang('通知详情')"
    :before-close="handleClose"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    top="10vh"
    class="addLink-dialog"
  >
    <div class="content" v-if="htmlStr||(pathsList&&pathsList.length)">
      <div class="content-top">
        <p>{{detailData.title||'--'}}</p>
        <div class="top-text">
          <span>{{detailData.showDayStart?detailData.showDayStart+' 8:30':'--'}}</span>
          <span>客服部</span>
          <span>阅读量 {{addSeparatorToNumber(detailData.viewCount)||'--'}}</span>
        </div>
      </div>
      <div v-html="htmlStr"></div>
      <div style="color:#E60012">
        <div class="path-item">
          <p
            style="cursor: pointer;text-align:center"
            v-for="(item,index) in pathsList"
            :key="index"
            @click="downloadPath(item)"
          >
            <i class="el-icon-document"></i>
            {{item.name}}
          </p>
        </div>
      </div>
    </div>
    <div v-else style="text-align:center">暂无数据</div>
  </el-dialog>
</template>
<script>
import { publicApi } from './pool'
import { addSeparatorToNumber } from '@/common/utils/tool.js'

export default {
  props: {
    visible: Boolean,
    html: String,
    paths: {
      type: Array,
      default: () => []
    },
    id: String
  },
  data() {
    return {
      htmlStr: '',
      pathsList: [],
      loading: false,
      detailData: {}
    }
  },
  mounted() {
    this.htmlStr = this.html || ''
    this.pathsList = this.paths || []
    this.getDetail(this.id)
  },
  methods: {
    addSeparatorToNumber,
    async getDetail(id) {
      if (!id) return
      this.loading = true
      this.htmlStr = ''
      this.pathsList = []
      const { data, code, msg } = await publicApi.reqDetail({ id }).catch(() => {
        this.handleClose()
        this.loading = false
      })
      this.loading = false
      if (code === 1) {
        const { content, pathMap } = data || {}
        this.htmlStr = content || ''
        Object.keys((pathMap || {})).map(key => {
          key && this.pathsList.push({
            name: key,
            url: pathMap[key]
          })
        })
        Object.assign(this.detailData, data)
      } else {
        this.handleClose()
        this.$message.error(msg)
      }
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
    downloadPath({ url, name }) {
      fetch(`${url}`)
        .then(response => response.blob())
        .then(blob => {
          var a = document.createElement('a');
          var url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = name || '';
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        })
        .catch(e => console.error('下载图片时出错:', e));
    }
  }
}
</script>
<style lang="scss" scoped>
.addLink-dialog {
  margin-top: 0vh;
  // height: calc(100vh);
  .content {
    height: calc(100vh - 300px) !important;
    overflow: auto;
  }
}
.path-item {
  width: 50%;
  text-align: left;
  margin: 0 auto;
}
.content-top {
  text-align: center;
  &>p {
    font-size: 18px;
    font-weight: bolder;
  }
  .top-text {
    display: flex;
    justify-content: center;
    span {
      margin: 0 30px;
      // font-weight: bold;
    }
  }
}
</style>
